import clsx from 'clsx'

/* styling */
import styles from './_.module.css'

function ElevateProposition(): JSX.Element {
  return (
    <section
      className={clsx(styles.propositionContainer, 'pt-16 pb-32 lg:py-22')}
    >
      <div className="max-width-container | grid grid-cols-1 md:grid-cols-12 gap-20 md:gap-8">
        <div className="md:col-span-6 lg:col-span-5">
          <h2 className="font-heading text-4xl lg:text-5xl text-white font-semibold | mb-7 lg:mb-10">
            About Elevate 2023
          </h2>
          {stats.map(stat => (
            <div key={stat.value} className="border-b | max-w-sm | py-5">
              <h3 className="text-[#070425]">
                <span className="font-heading text-5xl font-medium | block | mb-1">
                  {stat.value}
                </span>
                <span className="font-heading text-2xl | block ">
                  {stat.title}
                </span>
              </h3>
            </div>
          ))}
        </div>

        <div className="md:col-span-6 lg:col-start-7 lg:col-span-6 | space-y-8 lg:space-y-12">
          {proposition.map(item => (
            <div key={item.title}>
              <h3 className="text-white text-2xl lg:text-3xl font-semibold | mb-4">
                {item.title}
              </h3>
              <p className="text-[#070425] text-sm lg:text-lg">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

const stats = [
  { title: 'Speakers', value: '25+' },
  { title: 'Attendees', value: '5000+' },
  { title: 'Sessions', value: '15+' }
]

const proposition = [
  {
    title: 'Hear From The Experts',
    description:
      'Learn exclusively from entrepreneurs, content marketing leaders, AI experts, and industry specialists.'
  },

  {
    title: 'Productive Networking',
    description:
      'Connect with some of the most passionate leaders in the content industry and explore potential collaboration opportunities. '
  },

  {
    title: 'Stay Ahead Of The Curve',
    description:
      'Find out how AI is revolutionizing the content industry. Understand the growth prospects and latest trends driving the business landscape.'
  },

  {
    title: 'Humans + AI = 💙',
    description:
      'Leverage AI to its full potential to enhance the productivity and creativity of your content team.'
  }
]

export default ElevateProposition
